import { render, staticRenderFns } from "./SFormCashRegisterComp.vue?vue&type=template&id=2655aa81&"
import script from "./SFormCashRegisterComp.vue?vue&type=script&lang=js&"
export * from "./SFormCashRegisterComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports